module.exports = __webpack_public_path__ + "static/media/sg1tj44.01ac6ba1.png";